"use client";

import { ReactNode } from "react";
import { useSpanishExperienceEnabled } from "@/lib/locale/useSpanishExperienceEnabled";

type FooterLocaleSwitcherFeatureProps = {
  children: ReactNode;
};

export function FooterLocaleSwitcherFeature({
  children,
}: FooterLocaleSwitcherFeatureProps) {
  const { isEnabled: isSpanishMvpEnabled, isLoading: isSpanishLoading } =
    useSpanishExperienceEnabled();

  if (isSpanishLoading || isSpanishMvpEnabled) {
    return null;
  }

  return children;
}
